import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class AppInsightsHttpInterceptor implements HttpInterceptor {
  constructor(private appInsightsService: ApplicationInsightsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Логируем каждый исходящий HTTP-запрос
    this.appInsightsService.logEvent('HTTP Request', {
      url: req.url,
      method: req.method,
      withCredentials: req.withCredentials,
      headers: req.headers.keys().join(', ')
    });
    return next.handle(req).pipe(
      tap({
        next: (event) => {
          // Можно логировать успешные ответы, если нужно
        },
        error: (error: HttpErrorResponse) => {
          // Логируем ошибку HTTP-запроса
          this.appInsightsService.logException(
            error instanceof Error ? error : new Error(error.message || 'HTTP error'),
            3
          );
        }
      })
    );
  }
}
